import ReactValidator from "legacy/ReactValidator.es6"
import ForgotPassword from "legacy/auth/ForgotPassword"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) is loaded globally

class AuthLogin extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: "",
      password: "",
      validationMessage: null,
      processing: false,
    }
    this.validator = new ReactValidator(["email", "password"])
    this.handleInputChange = this.handleInputChange.bind(this)
    this.goToForgotPassword = this.goToForgotPassword.bind(this)
    this.submit = this.submit.bind(this)
    this.postToLogIn = this.postToLogIn.bind(this)
  }

  handleInputChange(event) {
    const name = event.target.name
    const val = event.target.value
    this.setState({ [name]: val })
  }

  goToForgotPassword() {
    this.props.setView(
      <ForgotPassword
        email={this.state.email}
        setLoginPage={this.props.setLoginPage}
      />
    )
  }

  submit() {
    this.validator.displayErrors()
    this.setState({ validInputs: this.validator.allValid() })
    if (this.validator.allValid() === true) {
      this.setState({ processing: true })
      this.setState({ validationMessage: "" })
      this.postToLogIn()
    }
  }

  postToLogIn() {
    $.post(
      "/users/sign_in",
      {
        "user[email]": this.state.email.trim(),
        "user[password]": this.state.password,
      },
      (data) => {
        location.reload()
      },
      "json"
    ).fail((data) => {
      this.setState({
        validationMessage: JSON.parse(data.responseText).error,
        processing: false,
      })
    })
  }

  render() {
    return (
      <div>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <div className="form-control-with-icon">
            <i className="fa-solid fa-envelope form-control-icon-left" />
            <input
              className="form-control"
              name="email"
              type="email"
              id="email"
              value={this.state.email}
              onChange={this.handleInputChange}
            />
            {this.validator.message(
              "email",
              this.state.email,
              "required|email"
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <div className="form-control-with-icon">
            <i className="fa-solid fa-key form-control-icon-left" />
            <input
              type="password"
              className="form-control"
              name="password"
              id="password"
              value={this.state.password}
              onChange={this.handleInputChange}
            />
            {this.validator.message(
              "password",
              this.state.password,
              "required"
            )}
            {this.validator.customMessage(this.state.validationMessage)}
          </div>
        </div>
        <div
          className="text-muted bs-mb-4 forgot-password-btn"
          onClick={this.goToForgotPassword}
        >
          Forgot Password?
        </div>
        <p>
          By logging in, you are agreeing to the following terms (
          <a href="https://ahoy.dockwa.com/about-us/terms-of-service">
            Terms of Service
          </a>
          ,{" "}
          <a href="https://ahoy.dockwa.com/about-us/saas-terms-of-service">
            SaaS Agreement
          </a>
          , <a href="https://ahoy.dockwa.com/privacy">Privacy Policy</a>).
          Please note the SaaS Agreement applies to marina users only.
        </p>
        <NextButton
          processing={this.state.processing}
          click={this.submit}
          icon="fa-lock bs-mr-3"
          iconStyle="solid"
          text="Log In"
          processingText="Logging In..."
          btnClass="btn-primary"
        />
      </div>
    )
  }
}

AuthLogin.propTypes = {
  setView: PropTypes.func.isRequired,
  setLoginPage: PropTypes.func.isRequired,
}

export default AuthLogin
